import { useDispatch } from 'react-redux';

import { PipesAPI } from '../api/pipes.api';
import { decoratePipe } from '../redux-store/reducers/decoratePipe';
import { setInternalPipes } from '../redux-store/reducers/internalPipes.reducer';
import { getInternalDataEntities } from 'src/utils/commonDataEntities.utils';

import type { PipeResponse } from '../types/pipes.types';

export const useLoadInternalPipes = (subUrl: string, token: string) => {
  const dispatch = useDispatch();

  const loadInternalPipes = async () => {
    if (!token) {
      return;
    }

    PipesAPI.getAll(
      {
        subUrl,
        token,
      },
      true
    ).then((allPipes) => {
      const filtered = getInternalDataEntities<PipeResponse>(allPipes).map((p: PipeResponse) =>
        decoratePipe(p)
      );

      dispatch(setInternalPipes(filtered));
    });
  };

  return { loadInternalPipes };
};
